import StackKit from "@/shared/components/kit/stack";
import { useEffect, useState } from "react";
import WalletManagement from "../components/home/walletManagement";
import WalletBalance from "../components/home/walletBalance";
import TwentyCardCenters from "../components/home/twentyCardCenters";
import Slider from "../components/home/slider";
import { CssBaseline, ThemeProvider } from "@mui/material";
import WalletReports from "../components/home/walletReports";
import Transactions from "../components/home/transactions";
import Layout from "../layout/main";
import theme from "../theme";
import CreditPurchases from "../components/home/creditPurchases";
import { useMutation } from "@tanstack/react-query";
import { postTransactions } from "@/api/user/home";
import BoxKit from "@/shared/components/kit/box";
/**
 * HomeUser
 *
 * صفحه اصلی کاربران که داشبورد کیف پول، تراکنش‌ها، گزارش ها و خرید اعتباری را نمایش می‌دهد.
 *
 * @returns JSX.Element
 */
// Task Response:

// کد صفحه HomeUser درست است و کامپوننت‌ها به درستی سازماندهی شده‌اند.
// تنها نکته بهینه‌سازی: useEffect بدون dependency array به صورت خالی می‌تواند هشدار دهد، بهتر است page و size به آرایه dependency اضافه شوند:
const HomeUser = () => {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const { mutate: fetchTransactions, data } = useMutation({
    mutationFn: postTransactions,
  });
  
  useEffect(() => {
    fetchTransactions({ page: page, size: size });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
        {/* ======= Top Section ======= */}
        <StackKit className="w-full mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
            {/* Left column */}
            <div className="lg:col-span-1">
              <WalletManagement />
            </div>

            {/* Middle column */}
            <div className="lg:col-span-1 flex flex-col gap-4">
              <WalletBalance />
              <TwentyCardCenters />
            </div>

            {/* Right column */}
            <div className="md:col-span-2 lg:col-span-2">
              <Slider />
            </div>
          </div>
        </StackKit>


        {/* ======= Reports + Transactions Section ======= */}
        <StackKit className="w-full mt-6 flex flex-col gap-4 mx-auto">
          <div className="flex flex-col md:flex-row justify-between gap-4w-full">
            <BoxKit className="w-full md:w-[65%] lg:w-[70%]">
              <WalletReports data={data} />
            </BoxKit>
            <BoxKit className="w-full md:w-[33%] lg:w-[28%]">
              <Transactions data={data} />
            </BoxKit>
          </div>

          {/* ======= Credit Purchases ======= */}
          <BoxKit className="w-full mx-auto">
            <CreditPurchases />
          </BoxKit>
        </StackKit>

        <StackKit direction="row" className="w-full mx-auto"></StackKit>
      </Layout>
    </ThemeProvider>

  );
};

export default HomeUser;
